export const alloyPrehidingScript = `!(function(e, n, t, o) {
	if (!n) {
		var i = e.head;
		if (i) {
			var a = e.createElement("style");
			(a.id = "alloy-prehiding"), (a.innerText = t), i.appendChild(a);
			var d = setTimeout(function() {
				r();
			}, 3e3);
			fetch("//cdn.tt.omtrdc.net/cdn/target-vec.js", {
					method: "HEAD",
					mode: "no-cors",
				})
				.then(function() {})
				.catch(function() {
					clearTimeout(d), r();
				});
		}
	}
	function r() {
		var e = document.getElementById("alloy-prehiding");
		e && e.parentNode && e.parentNode.removeChild(e);
	}
})
(document, -1 !== document.location.href.indexOf("adobe_authoring_enabled"), "#quiz { opacity: 0 !important }", 2000);`;

export const alloyBootstrapScript = `!function(n,o){o.forEach(function(o){n[o]||((n.__alloyNS=n.__alloyNS||
   []).push(o),n[o]=function(){var u=arguments;return new Promise(
   function(i,l){n[o].q.push([i,l,u])})},n[o].q=[])})}
   (window,["alloy"]);`;

export const alloyConfigurationScript = (
  datastreamId: string | undefined,
) => ` alloy("configure", {
                        "datastreamId": "${datastreamId}",
                        "orgId": "3B821E7566CD079F0A495F87@AdobeOrg",
                        "edgeDomain": "smetrics.mattressfirm.com"
                    }).then(function() {
                        alloy("sendEvent", {
                            "renderDecisions": true,
                            "type": "decisioning.propositionFetch",
                            "personalization": {
                                "sendDisplayEvent": false
                            }
                          }).then(function(event) {
                          var propositions = event.propositions;
                          if (typeof propositions != "undefined") {
                              window.ttMETA = window.ttMETA || [];
                              for (var i = 0; i < propositions.length; i++) {
                                  if (propositions[i].items && propositions[i].items[0] && propositions[i].items[0].meta && propositions[i].items[0].meta["activity.name"] && propositions[i].items[0].meta["experience.name"]) {
                                      var campaignName = propositions[i].items[0].meta["activity.name"];
                                      var experienceName = propositions[i].items[0].meta["experience.name"];
                                      window.ttMETA.push({
                                          CampaignName: campaignName,
                                          RecipeName: experienceName,
                                      });
                                  }
                              }
                          }
                      });
            });
 `;
